import omit from 'lodash/omit'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { useLocation, useNavigate } from 'react-router-dom'
import SmsTemplateForm from './SmsTemplateForm'
import usePermissions from '@/hooks/usePermissions'
import Redirect from '@/components/Redirect'

const mapStateToProps = () => ({})

const SmsTemplateEdit = ({ dispatch }) => {
  const { t } = useTranslation()
  // const [labelList, setLabelList] = useState([])
  const [extendResponse, setExtendResponse] = useState({})

  const navigate = useNavigate()
  const { state } = useLocation()
  const { smsTempId, type } = state || {}
  const canModify = usePermissions(
    type === 'system' ? 'smsTempSystem_modify' : 'smsTempPerson_modify',
  )

  const formData = {
    smsTempId,
    ...extendResponse,
  }

  useEffect(() => {
    dispatch({
      type: 'smsTemplate/getSmsTemplateById',
      payload: { smsTempId },
      successCallback: response => {
        setExtendResponse(response)
      },
    })
  }, [dispatch, smsTempId])

  const onSubmit = payload => {
    const transformPayload = omit(payload, 'type')

    dispatch({
      type: 'smsTemplate/editSmsTemplate',
      payload: { ...transformPayload, smsTempId },
      successCallback: () => {
        dispatch({
          type: 'app/notify',
          payload: { message: t('messages.sms_template_updated'), severity: 'success' },
        })
        navigate(`/phish_template_sms/${type || 'system'}`, { replace: true })
      },
    })
  }
  if (!canModify) return <Redirect />
  
  return <SmsTemplateForm onSubmit={onSubmit} data={formData} type={type} />
}

export default connect(mapStateToProps)(SmsTemplateEdit)
